<!--
 * @Description: 项目执行人年龄对比分析
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div class="bi-tmpl-detail__right__cmpt">
    <div>
      <span class="bi-tmpl-detail__right__cmpt__title">
        {{ curItem.title }}
      </span>
      <span v-if="curItem.tips" class="bi-tmpl-detail__right__cmpt__tips">
        {{ curItem.tips }}
      </span>
    </div>
    <Carousel ref="carouselRef" :itemHeight="200" :itemWidth="420 + 56">
      <div
        style="height: 200px; width: 100%"
        v-for="(item, index) in TYPE_MAPPING"
        :key="index"
        @click="onChange(item.value)"
      >
        <BaseCard style="width: 420px; height: 200px">
          <BaseRadio
            class="bi-tmpl-detail__right__cmpt__radio bi-tmpl-detail__right__cmpt__radio--w"
            :value="item.value"
            :model-value="curItem.value"
          >
            <div
              v-if="item.svg"
              v-html="item.svg"
              style="margin-top: 24px"
            ></div>
            <div
              v-else
              style="height: 120px; display: flex; align-items: center"
            >
              <component
                :style="
                  index === 6 && {
                    transform: 'scaleX(1.8) scaleY(1.2) translateY(10px)'
                  }
                "
                :colorList="colorList"
                :is="cmpName(item.value)"
              />
            </div>
          </BaseRadio>
        </BaseCard>
      </div>
    </Carousel>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { BaseRadio } from 'xrk-components';
import { BaseCard } from 'xrk-components';
import { Carousel } from '@/components/base/carousel';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import PcModuleAge from '../../../../../bi-pc-module/pc-module-age-comparison/index';

const CHILD_KEY = '4_2_2';
const TYPE_MAPPING: Array<{ value: any; index: number; svg?: string }> = [
  ...[1, 2, 3, 4, 5, 6, 7].map(i => {
    return {
      value: 'pc-module-age-comparison-' + i,
      index: i
    };
  })
];

const cmpName = name => {
  return PcModuleAge.filter(comp => comp.__name === name)[0];
};

const { curItem, onChange, state } = useDetailCmpt({ childKey: CHILD_KEY });

const colorList = ref(
  state.value.menuValue.get('101').value['101_1'].value.split(',')
);
</script>
